import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.get('/customer-api/company-relation-group-limits/page', params)

// 删除
export const removeItem = id =>
  request.get(`/customer-api/company-relation/relation/delete/${id}`)

// 新增
export const add = params =>
  request.post('/customer-api/company-relation-group-limits', params)

export const screeningParentCompany = name =>
  request.get(`/customer-api/customer/list/${name}`)

// 失效
export const setInvalid = (id, companyId) =>
  request.post(
    `/customer-api/company-relation-group-limits/inactive/${id}/${companyId}`,
  )

export const update = (id, params) =>
  request.put(`/customer-api/company-relation-group-limits/${id}`, params)
